module.exports = {
  production: {
    NODE_ENV: '"production"',
    SELLSUKI_LOGIN_PORTAL: '"https://oms-login.akitahub.com/#/choosestore?target=gw-pos"',
    SELLSUKI_LOGOUT_PORTAL: '"https://oms-login.akitahub.com/#/logout?target=gw-pos"',
    SELLSUKI_URL: '"https://oms-api.akitahub.com/"',
    CF_URL: '"https://us-central1-promocode-95a0c.cloudfunctions.net/app"',
    FB_APIKEY: '"AIzaSyBRupnI-oO_O1e1m_Uxk1Ywa-J3mCrTmxs"',
    FB_AUTHDOMAIN: '"promocode-95a0c.firebaseapp.com"',
    FB_DATABASEURL: '"https://promocode-95a0c.firebaseio.com"',
    FB_PROJECTID: '"promocode-95a0c"',
    FB_STORAGEBUCKET: '"promocode-95a0c.appspot.com"',
    FB_MESSAGINGSENDERID: '"302114698777"',
    STORE_POS_BRANCH_ID: '"440"',
    INFOBIP_URL: '"https://api.infobip.com/sms/1/text/single"',
    POS_UNIT_ID: '"403"',
    CF_FETCH_DATA: '"https://us-central1-promocode-95a0c.cloudfunctions.net/fetchdata"',
    NEW_API: '"https://production-api-dclzrwc4na-an.a.run.app"',
    PRINT_API: '"https://gw-print-proxy-api.akitahub.com"'
  },
  staging: {
    NODE_ENV: '"development"',
    SELLSUKI_LOGIN_PORTAL: '"http://staging-oms-login.akitahub.com/#/choosestore?target=gw-pos"',
    SELLSUKI_URL: '"https://staging-oms-api.akitahub.com"',
    SELLSUKI_LOGOUT_PORTAL: '"http://staging-oms-login.akitahub.com/#/logout?target=gw-pos"',
    CF_URL: '"https://us-central1-gw-staging-1d262.cloudfunctions.net/app"',
    FB_APIKEY: '"AIzaSyB9Oxj-YrjBFXE1sBQVKnrNrm89kFUirKk"',
    FB_AUTHDOMAIN: '"gw-staging-1d262.firebaseapp.com"',
    FB_DATABASEURL: '"https://gw-staging-1d262.firebaseio.com"',
    FB_PROJECTID: '"gw-staging-1d262"',
    FB_STORAGEBUCKET: '"gw-staging-1d262.appspot.com"',
    FB_MESSAGINGSENDERID: '"741539713315"',
    INFOBIP_URL: '"https://api.infobip.com/sms/1/text/single"',
    STORE_POS_BRANCH_ID: '"195"',
    POS_UNIT_ID: '"172"',
    CF_FETCH_DATA: '"https://us-central1-gw-staging-1d262.cloudfunctions.net/fetchdata"',
    NEW_API: '"https://camp-stg.herokuapp.com"',
    PRINT_API: '"https://staging-gw-print-proxy-api.akitahub.com"'
  },
  development: {
    NODE_ENV: '"development"',
    SELLSUKI_LOGIN_PORTAL: '"http://staging-oms-login.akitahub.com/#/choosestore?target=gw-local"',
    SELLSUKI_URL: '"https://staging-oms-api.akitahub.com"',
    SELLSUKI_LOGOUT_PORTAL: '"http://staging-oms-login.akitahub.com/#/logout?target=gw-local"',
    CF_URL: '"https://us-central1-gw-staging-1d262.cloudfunctions.net/app"',
    FB_APIKEY: '"AIzaSyB9Oxj-YrjBFXE1sBQVKnrNrm89kFUirKk"',
    FB_AUTHDOMAIN: '"gw-staging-1d262.firebaseapp.com"',
    FB_DATABASEURL: '"https://gw-staging-1d262.firebaseio.com"',
    FB_PROJECTID: '"gw-staging-1d262"',
    FB_STORAGEBUCKET: '"gw-staging-1d262.appspot.com"',
    FB_MESSAGINGSENDERID: '"741539713315"',
    INFOBIP_URL: '"https://api.infobip.com/sms/1/text/single"',
    STORE_POS_BRANCH_ID: '"195"',
    POS_UNIT_ID: '"172"',
    CF_FETCH_DATA: '"https://us-central1-gw-staging-1d262.cloudfunctions.net/fetchdata"',
    NEW_API: '"https://camp-stg.herokuapp.com"',
    PRINT_API: '"https://staging-gw-print-proxy-api.akitahub.com"'
  }
}



// WEBPACK FOOTER //
// ./src/config/url.js